import React from "react";

export const LogoMarquee = ({logos}) => {
    const doubled = logos.concat(logos);
    return (
        <div className="marquee-container w-full">
            <div className="marquee-content">
                {doubled.map((logo, index) => (
                    logo.href
                        ? <a key={index} href={logo.href} className="logo-link" aria-label={`Visit ${logo.alt} website`} target="_blank" rel="noopener noreferrer">
                            <img src={logo.src} alt={logo.alt} width="120" height="30" loading="lazy" decoding="async"/>
                        </a>
                        : <span key={index} className="logo-link">
                            <img src={logo.src} alt={logo.alt} width="120" height="30" loading="lazy" decoding="async"/>
                        </span>
                ))}
            </div>
        </div>
    );
};

const LogoStrip = ({logos, label, className = ""}) => (
    <section className={`w-full max-w-screen-2xl mx-auto px-5 ${className}`}>
        <div className="w-full bg-[var(--cl-surface)] border-t border-b border-[var(--cl-rule)] pt-5 pb-5">
            {label ? <p className="cl-eyebrow text-center mb-3 px-4">{label}</p> : null}
            <LogoMarquee logos={logos}/>
        </div>
    </section>
);

export default LogoStrip;
